export default __webpack_public_path__ + "static/media/Politica Qualità FCSI.12ccc9b6.pdf";